import script from "./PasswordChangeStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordChangeStep.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordChangeStep.vue?vue&type=style&index=0&id=3dfa6509&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dfa6509"]])

export default __exports__